import { ValueOf } from '@/types/util';

export const EScheduleBalanceType = {
  BONUS_VALUE: 'ボーナスバリュー',
  BASIC_POINT: '通常ポイント',
  BONUS_POINT: 'ボーナスポイント',
} as const;

export const EBalanceType = {
  PREPAID_VALUE: '前払バリュー',
  FUNDS_TRANSFER_VALUE: '資金移動バリュー',
  ...EScheduleBalanceType,
} as const;

export type BalanceTypeKey = keyof typeof EBalanceType;
export type BalanceTypeValue = ValueOf<typeof EBalanceType>;

export const BalanceTypeKeys = Object.keys(EBalanceType) as (BalanceTypeKey[]);

/** v-select用items */
export const balanceTypeItems = BalanceTypeKeys
  .map((key) => ({
    title: EBalanceType[key],
    value: key,
  }));

export const balanceUnit: Record<BalanceTypeKey, 'pt' | '円'> = {
  PREPAID_VALUE: '円',
  FUNDS_TRANSFER_VALUE: '円',
  BONUS_VALUE: '円',
  BASIC_POINT: 'pt',
  BONUS_POINT: 'pt',
};

export type ScheduleBalanceTypeKey = keyof typeof EScheduleBalanceType;
export const ScheduleBalanceTypeKeys = Object.keys(EScheduleBalanceType) as (BalanceTypeKey[]);
